
export enum FormPlaceholderLayout {
	Basic = 0,
	Advanced = 1
}

export interface IFormPlaceholderAdvanced {
	rows: IFormPlaceholderAdvancedRow[];
}

export interface IFormPlaceholderAdvancedRow {
	columns?: IFormPlaceholderAdvancedColumn[];
	width?: string;
	height?: string;
	isShiny?: boolean;
	classList?: string;
}

export interface IFormPlaceholderAdvancedColumn {
	width?: string;
	height?: string;
	isShiny?: boolean;
	classList?: string;
}

